import { createTheme } from "@mui/material";

export const themeSystemMui = createTheme({
  palette: {
    primary: {
      main: "#00A758",
    },
  },
});
